import { PlanLimitConfigs, BillingCycleConfig } from "../types.ts";

export const TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE = "MONTHLY";
export const TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT = 300;

export const TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT = 801;

export const teamworkCollectionOfferingSkus = {
    free: "teamwork-collection-free-sku",
    standard: "teamwork-collection-standard-sku",
    premium: "teamwork-collection-premium-sku",
    enterprise: "teamwork-collection-enterprise-sku"
} as const;

export const teamworkCollectionOfferingSkusArray = Object.values(
    teamworkCollectionOfferingSkus
);

export const teamworkCollectionPlanLimitConfigs: PlanLimitConfigs[] = [
    {
        planName: "Free",
        offeringSku: teamworkCollectionOfferingSkus.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: "Standard",
        offeringSku: teamworkCollectionOfferingSkus.standard,
        recommendationLimit: 0,
        signupLimit: 100_000
    },
    {
        planName: "Premium",
        offeringSku: teamworkCollectionOfferingSkus.premium,
        recommendationLimit: 0,
        signupLimit: 100_000
    },
    {
        planName: "Enterprise",
        offeringSku: teamworkCollectionOfferingSkus.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100_000,
        minUnitCount: TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT
    }
];

export const teamworkCollectionBillingCycleConfig: BillingCycleConfig = {
    monthly: true,
    annual: true
};
